'use client'

import { parseAsString, useQueryStates } from 'nuqs'
import { URLSearchParamKeys } from "@/enum/URLSearchParamKeys"

export function usePlaylistTrackQueryState() {
  const [, setQueryStates] = useQueryStates(
    {
      [URLSearchParamKeys.TRACK]: parseAsString.withDefault(''),
      [URLSearchParamKeys.PLAYLIST]: parseAsString.withDefault(''),
      [URLSearchParamKeys.Q]: parseAsString.withDefault(''),
    },
    {
      history: 'push',
      shallow: true,
      clearOnDefault: true,
    }
  )

  const setPlaylistAndTrackQueryState = (
    playlistId: string,
    trackId: string,
  ) => {
    setQueryStates({
      [URLSearchParamKeys.PLAYLIST]: playlistId,
      [URLSearchParamKeys.TRACK]: trackId,
      [URLSearchParamKeys.Q]: '',
    })
  }

  const unsetPlaylistAndTrackQueryState = () => {
    setQueryStates({
      [URLSearchParamKeys.PLAYLIST]: '',
      [URLSearchParamKeys.TRACK]: '',
      [URLSearchParamKeys.Q]: '',
    });
  };

  return {
    unsetPlaylistAndTrackQueryState,
    setPlaylistAndTrackQueryState,
  }
}